import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.size || 18}
            height={props.size * (23 / 18) || 23}
            viewBox="0 0 18 23"
            fill="none"
            {...props}
        >
            <path
                d="M17.425 7.983c-.128.1-2.392 1.376-2.392 4.212 0 3.281 2.88 4.442 2.967 4.471-.013.07-.458 1.59-1.519 3.137-.946 1.363-1.935 2.722-3.438 2.722-1.504 0-1.89-.873-3.626-.873-1.692 0-2.293.902-3.668.902-1.376 0-2.335-1.26-3.438-2.808C1.033 17.929 0 15.106 0 12.426c0-4.299 2.795-6.579 5.545-6.579 1.462 0 2.68.96 3.598.96.873 0 2.235-1.017 3.898-1.017.63 0 2.894.057 4.384 2.193zM12.251 3.97c.688-.816 1.174-1.948 1.174-3.08 0-.157-.013-.316-.042-.444-1.118.042-2.45.745-3.252 1.676-.63.716-1.218 1.848-1.218 2.996 0 .172.028.345.042.4.07.013.185.029.3.029 1.004 0 2.267-.672 2.996-1.577z"
                fill="#313131"
            />
        </svg>
    );
}

export default SvgComponent;
